import { useGetRedefinirSenha } from "hooks/usuario/useGetRedefinirSenha";
import { usePostResetPassword } from "hooks/usuario/usePostResetPassword";
import NewPassword from "./NewPassword";

interface ResetPasswordProps {
  urlToken: string;
}

export const ResetPassword: React.FC<ResetPasswordProps> = (props) => {
  const { mutate: postResetPassword } = usePostResetPassword();
  const { data: username } = useGetRedefinirSenha(props.urlToken);

  return (
    <NewPassword
      urlToken={props.urlToken}
      username={username}
      requestFn={postResetPassword}
      resetPassword
    />
  );
};
